import type { PresentationType } from './shipments-types.js';

export interface ListShipmentCandidateLinesRequest {
  companyId: string;
  rcScopeId: string;
  materialId: string;
  /** Inclusive lower bound for candidate filtering (`occurredAt >= occurredAtStart`). */
  occurredAtStart: string;
  /** Exclusive upper bound for candidate filtering (`occurredAt < occurredAtEnd`). */
  occurredAtEnd: string;
  presentationType?: PresentationType;
  includeAlreadyShipped?: boolean;
  limit?: number;
}

export const shipmentAvailabilityStatusValues = ['available', 'reserved', 'departed'] as const;
export type ShipmentAvailabilityStatus = (typeof shipmentAvailabilityStatusValues)[number];

export const shipmentAvailabilityReasonValues = [
  'available',
  'reserved_by_shipment',
  'reserved_by_cover_shipment',
  'departed_by_shipment',
  'departed_by_cover_shipment',
] as const;
export type ShipmentAvailabilityReason = (typeof shipmentAvailabilityReasonValues)[number];

export interface ShipmentCandidateLineItem {
  lineItemId: string;
  purchaseCommittedId: string;
  occurredAt: string;
  materialId: string;
  presentationType: PresentationType;
  netWeightLbs: number;
  pieces: number | null;
  equivalentLbs: number | null;
  lineTotalCents: number;
  baseRatePerLb: number | null;
  qualityDiscountMoneyCents: number;
  isCrvEligible: boolean;
  isReportedToDoriis: boolean;
  shipmentAvailabilityStatus: ShipmentAvailabilityStatus;
  shipmentAvailabilityReason: ShipmentAvailabilityReason;
  /**
   * @deprecated Compatibility field for older consumers. It now means the line is
   * unavailable by default, not necessarily physically shipped.
   */
  isAlreadyShipped: boolean;
}

export interface ShipmentCandidateLinesMeta {
  returned: number;
  limit: number;
}

export interface ListShipmentCandidateLinesResponse {
  items: ShipmentCandidateLineItem[];
  meta: ShipmentCandidateLinesMeta;
}
